import { debugDestroyNextVulnerableStructure } from '../../application/debugStructureDestroy.js';

/**
 * wireDebugStructureDestroy — Panel + window hook for chain-safe structure kills.
 * Never bypasses requires (inhib needs lane towers; not nexus turrets).
 */
export function wireDebugStructureDestroy({
  getStructures,
  getChampion,
  floatingTextUI,
  buttonId = 'kill-next-structure-btn'
} = {}) {
  function destroyNext(team = null) {
    const champion = getChampion ? getChampion() : null;
    const enemy = team || (champion?.team === 'blue' ? 'red' : 'blue');
    const structures = getStructures ? getStructures() : [];
    const result = debugDestroyNextVulnerableStructure(structures, enemy);
    if (floatingTextUI && result.structure) {
      const s = result.structure;
      if (result.ok) {
        floatingTextUI.showStatusText(
          s.x, s.z,
          `🏰 ${s.name || result.id} destruida`,
          '#f8fafc'
        );
      } else if (champion) {
        floatingTextUI.showStatusText(
          champion.x, champion.z,
          '🏰 Ninguna struct vulnerable (cadena)',
          '#94a3b8'
        );
      }
    }
    return result;
  }

  const btn = typeof document !== 'undefined'
    ? document.getElementById(buttonId)
    : null;
  if (btn) {
    btn.addEventListener('click', () => destroyNext());
  }

  if (typeof window !== 'undefined') {
    window.__debugDestroyNextStructure = destroyNext;
  }

  return { destroyNext };
}
